import { observer } from 'mobx-react-lite';
import { useWindowSize } from 'src/core/hooks';
import { ProductProps } from './product.props';
import styles from './product.module.scss';
import { Button } from 'src/core/components';

/**
 * <Product />
 */
const Product = observer<ProductProps>(
  ({ index, product, productsLength, locale }) => {
    const { width } = useWindowSize();

    const {
      name,
      border,
      taste,
      btnText,
      btnLink,
      imgMob,
      imgDesk,
      tarsText,
      tarsPoints,
      tars,
      gradient
    }: any = product;

    const points = () => {
      const pointsList: any = [];
      const full = tarsPoints.split('/')[1];
      const min = tarsPoints.split('/')[0];
      for (let i = 0; i < full; i++) {
        pointsList.push(
          <span className={i < min ? styles.full : styles.empty} key={i} />
        );
      }
      return pointsList;
    };
    return (
      <div className={styles.wrapper}>
        <div
          className={styles.product}
          style={{
            borderColor: border,
            backgroundImage:
              width > 1149
                ? `url(${imgDesk[locale]})`
                : `url(${imgMob[locale]})`
          }}
        >
          <div className={styles.header}>
            <div className={styles.left}>
              <p className={styles.pointsText}>{tarsText[locale]}</p>
              <span className={styles.points}>{points()}</span>
            </div>
            <span className={styles.tars}>{tars[locale]}</span>
          </div>
          {/* <img
          className={styles.img}
          src={width > 1149 ? imgDesk[locale] : imgMob[locale]}
        /> */}
          <div className={styles.btn_wrapper}>
            <h2 className={styles.name}>{name[locale]}</h2>
            <p className={styles.taste}>{taste[locale]}</p>
            <Button
              color='quaternary'
              className={styles.btn}
              link={btnLink[locale]}
            >
              {btnText[locale]}
            </Button>
          </div>
        </div>
      </div>
    );
  }
);

export { Product };
